let appDownloadUrl = 'http://47.96.131.222:8082/?type=3' // 好服务app下载url

export default {
  appDownloadUrl
}



// WEBPACK FOOTER //
// ./src/common/global.js